import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-re-usedcss',
  templateUrl: './re-usedcss.component.html',
  styleUrls: ['./re-usedcss.component.scss']
})
export class ReUsedcssComponent implements OnInit{
ngOnInit(): void {
  
}

headdata = [
  {
    admNo: 'AdmNo', examProgram: 'ExamProgram', className: 'ClassName', dob: "Date of Birth"
    , programName: 'ProgramName', section: 'Section', studentName: 'StudentName'
  }
]


table = [
  {
    admNo: 'AdmNo', examProgram: 'ExamProgram', className: 'ClassName', dob: "Date of Birth"
    , programName: 'ProgramName', section: 'Section', studentName: 'StudentName'
  }
]

onSubmit(){
  
}
}
